const VIDEOGAME_WITH_ROUNDS: RoundTypeVideogames[] = ['cs-go', 'valorant'];

const VIDEOGAMES_WITH_STATS: VideogameSlug[] = ['cs-go', 'dota-2', 'league-of-legends'];

const LOL_PLAYERS_ROLE_ORDER: LolPlayerRole[] = ['top', 'jun', 'mid', 'adc', 'sup'];

const RADAR_CHART_DATA_ORDER: (keyof StatsLolInChart)[] = [
  'first_towers',
  'towers',
  'kills',
  'inhibitors',
  'first_inhibitors',
  'first_nashors',
  'nashors',
  'drakes',
  'first_drakes',
  'first_heralds'
];

const CS_VIDEOGAME_TITLES: Record<string, CounterStrikeVersion> = {
  'Counter-Strike: Global Offensive': 'cs-go',
  'Counter-Strike 2': 'cs-2'
};

const CSGO_ROUNDS_CONFIG: RoundsConfig = {
  round_group_size: 15,
  overtime_size: 6
};

const CS2_ROUNDS_CONFIG: RoundsConfig = {
  round_group_size: 12,
  overtime_size: 6
};

const VALORANT_ROUNDS_CONFIG: RoundsConfig = {
  round_group_size: 12,
  overtime_size: 2
};

const OPPOSITE_SIDES: Record<SideRound, SideRound> = {
  'counter-terrorist': 'terrorist',
  terrorist: 'counter-terrorist'
};

const base = import.meta.env.BASE_URL;

const VIDEOGAMES_WITH_CUSTOM_MAPS: Partial<Record<VideogameSlug, string>> = {
  'lol-wild-rift': `${base}images/maps/lol.jpeg`,
  'league-of-legends': `${base}images/maps/lol.jpeg`,
  fifa: `${base}images/maps/fifa.jpeg`,
  'dota-2': `${base}images/maps/dota2.png`,
  'e-soccer': `${base}images/maps/esoccer.png`,
  'e-basketball': `${base}images/maps/ebasketball.png`,
  'e-hockey': `${base}images/maps/ehockey.png`,
  'e-tennis': `${base}images/maps/etennis.png`
};

const EBATTLE_SLUGS: EBattleSlug[] = ['e-soccer', 'e-basketball', 'e-hockey', 'e-tennis'];

const EBATTLE_SUBDIVISION_COUNTS: Record<EBattleSlug, number> = {
  'e-soccer': 2,
  'e-basketball': 4,
  'e-hockey': 3,
  'e-tennis': 3
};

export {
  CSGO_ROUNDS_CONFIG,
  CS2_ROUNDS_CONFIG,
  VALORANT_ROUNDS_CONFIG,
  CS_VIDEOGAME_TITLES,
  OPPOSITE_SIDES,
  VIDEOGAME_WITH_ROUNDS,
  VIDEOGAMES_WITH_STATS,
  VIDEOGAMES_WITH_CUSTOM_MAPS,
  LOL_PLAYERS_ROLE_ORDER,
  RADAR_CHART_DATA_ORDER,
  EBATTLE_SLUGS,
  EBATTLE_SUBDIVISION_COUNTS
};
